import { Button, EmptyState } from '@bifeai/ui';
import { RotateCcw, TriangleAlert } from 'lucide-react';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { reportClientError } from '../lib/report';

/** Pantalla cuando algo se rompe al dibujar una página. El error queda registrado en el panel admin. */
export function RouteError() {
  const error = useRouteError();
  useEffect(() => {
    if (!isRouteErrorResponse(error)) reportClientError(error, { boundary: 'route' });
  }, [error]);

  return (
    <div className="bf-center-screen">
      <EmptyState
        icon={<TriangleAlert />}
        title="Esta pantalla tuvo un problema"
        text="Ya quedó registrado para revisarlo. Recargá la página para seguir trabajando."
        action={
          <Button variant="primary" icon={<RotateCcw />} onClick={() => window.location.reload()}>
            Recargar
          </Button>
        }
      />
    </div>
  );
}
